import { CodeCells } from '../../components/CodeCells.js';
import type { UseCasePage } from '../../seo/marketingContent.js';
import { MarketingPage } from './MarketingPage.js';

/** The join code shown as an illustration. Matches the landing page's. */
const STAGE_CODE = 'GK7T2M';

/**
 * One room the product is used in, with the poll that room would actually run.
 *
 * The worked example is the point: a stranger deciding whether this fits their
 * all-hands wants to see the question, not a feature list.
 */
export function UseCase({ page }: { page: UseCasePage }) {
  return (
    <MarketingPage eyebrow="Live polls in the room" heading={page.heading} lede={page.lede}>
      <section className="landing-act">
        <div className="landing-act-inner">
          <h2>Why it works here</h2>
          <ul className="landing-features">
            {page.moments.map((moment) => (
              <li key={moment.title}>
                <h3>{moment.title}</h3>
                <p>{moment.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* The room's side, as on the landing page: the only black on the page,
          because the projector is the only claim the audience experiences. */}
      <section className="stage-panel landing-room">
        <div className="landing-act-inner landing-room-inner">
          <div className="landing-room-copy">
            <p className="eyebrow">On the screen</p>
            <h2>{page.example.question}</h2>
            <ul className="marketing-example-options">
              {page.example.options.map((option) => (
                <li key={option}>{option}</li>
              ))}
            </ul>
          </div>
          {/* Hidden for the reason CodeCells is hidden on the landing page: it
              labels itself with a join code that leads to no poll. */}
          <div className="landing-room-screen" aria-hidden="true">
            <p className="join-url">floorpoll.app/j/{STAGE_CODE}</p>
            <CodeCells code={STAGE_CODE} size="lg" />
          </div>
        </div>
      </section>
    </MarketingPage>
  );
}
